import React, { Component } from 'react'; // eslint-disable-line
import Select from 'react-select';
import Dialog from '../common/Dialog';
// sermons class added
class DialogSelectList extends Component {
    mapPagesToSelect(items) {
        if (items) {
            return items.map((item) => {
                return {
                    value: item[this.props.valueKey],
                    label: item[this.props.labelKey],
                };
            });
        }
        return [];
    }

    render() {
        const {
            visible,
            items,
            close,
            onSelect,
            description,
            icon,
            buttonContent,
            hideSelect,
        } = this.props;

        const itemList = this.mapPagesToSelect(items);

        return (
            <Dialog
                Visible={visible}
                ExecuteAction={this.selectPageFn}
                ShowButtons={false}
                CloseDialog={close}
            >
                {icon}
                <div className="form-control form-control__dialog sermons">
                    <label>{description}</label>
                    {!hideSelect
        && (
            <Select
                options={itemList}
                className="form-selector"
                classNamePrefix="form-selector"
                onChange={onSelect}
                clearable={false}
                disabled={itemList.length === 0}
            />
        )}
                    {buttonContent
        && (
                    // eslint-disable-next-line react/button-has-type
            <button
                data-qa="auth-to-vimeo"
                id="vimeo-auth"
                className="btn btn-sq btn-dark btn-sm dialog-launcher"
                onClick={this.props.handleAuth}
            >
                {buttonContent}
            </button>
        )}
                </div>
            </Dialog>
        );
    }
}

export default DialogSelectList;
